
import {JsonPageContent} from "~/modules/common/services/util/async-loader";

import * as index_json from "~/content/index.json";
import * as dashboard_json from "~/content/dashboard.json";
import * as knowledge_json from "~/content/knowledge.json";
import * as icon_map_json from "~/content/iconMap.json";
import * as elements_json from "~/content/elements.json";
import * as messages_json from "~/content/messages.json";
import * as shop_json from "~/content/shop.json";
import * as successStories_json from "~/content/successStories.json";
import * as dbCarousel_json from "~/content/dbCarousel.json";
import * as vertriebkontaktieren_json from "~/content/vertriebkontaktieren.json";
import * as errormessages_json from "~/content/errormessages.json";
import * as modal_login_json from "~/content/modal_login.json";
import * as user_icons_json from "~/content/userIcons.json";

import {defineStore} from "pinia";

interface State {
  _ready: boolean;
  _store: { [key: string]: JsonPageContent | any };
}

export const useContentStore = defineStore('content', {
  state: (): State => ({
    _ready: false,
    _store: {}
  }),

  getters: {
    ready: state => {
      return state._ready;
    },
    getContent: (state) => (key: string) => (state._store[key])
  },

  actions: {
    async initialize() {
      if (!this.$state._ready) {
        const { $logger } = useNuxtApp();

        $logger.info('initializing content holder');

        const storeMap: { [key: string]: JsonPageContent | any } = {};

        storeMap['index'] = JSON.parse(JSON.stringify(index_json))['default'];
        storeMap['dashboard'] = JSON.parse(JSON.stringify(dashboard_json))['default'];
        storeMap['knowledge'] = JSON.parse(JSON.stringify(knowledge_json))['default'];
        storeMap['iconMap'] = JSON.parse(JSON.stringify(icon_map_json))['default'];
        storeMap['elements'] = JSON.parse(JSON.stringify(elements_json))['default'];
        storeMap['messages'] = JSON.parse(JSON.stringify(messages_json))['default'];
        storeMap['shop'] = JSON.parse(JSON.stringify(shop_json))['default'];
        storeMap['successStories'] = JSON.parse(JSON.stringify(successStories_json))['default'];
        storeMap['vertriebkontaktieren'] = JSON.parse(JSON.stringify(vertriebkontaktieren_json))['default'];
        storeMap['errormessages'] = JSON.parse(JSON.stringify(errormessages_json))['default'];
        storeMap['modal_login'] = JSON.parse(JSON.stringify(modal_login_json))['default'];
        storeMap['dbCarousel'] = JSON.parse(JSON.stringify(dbCarousel_json))['default'];
        storeMap['user_icons'] = JSON.parse(JSON.stringify(user_icons_json))['default'];

        this.$state._store = storeMap;
        this.$state._ready = true;

        $logger.info('content holder initialized');
      }
    }
  }
})
